import { createContext, useState } from 'react';

export const GlobalContext = createContext();

const GlobalContextProvider = ({ children }) => {
  const [someValue, setSomeValue] = useState('test property');
  return (
    <GlobalContext.Provider value={{ someValue, setSomeValue }}>
      {children}
    </GlobalContext.Provider>
  );
};

export default GlobalContextProvider;
